import Vuex from 'vuex';
import defaultStates from './state/state';
import mutations from './mutations/mutations';
import actions from './actions/actions';
import getters from './getters/getters';
import art_home from './modules/art_home';
import art_Number from './modules/art_number';
import a_index from './modules/a_index';
import pageHome from './modules/pageHome';
import pageProDetail from './modules/pageProDetail';
import pageMeetingList from './modules/pageMeetingList';
import pageMeetingDetail from './modules/pageMeetingDetail';
import pageSpecialDetail from './modules/pageSpecialDetail';
import pageOrganDetail from './modules/pageOrganDetail';
import pageBrand from './modules/pageBrand';
import pageBrandList from './modules/pageBrandList';
import pageCompany from './modules/pageCompany';
import pagesetMeta from './modules/pagesetMeta';
import pageOrgMeta from './modules/pageOrgMeta';
import pageProductMeta from './modules/pageProductMeta';


export function createStore () {
    const store= new Vuex.Store({
        modules: {
			artHome:art_home,
            artNumber:art_Number,
            AIndex:a_index,
            pageHome:pageHome,
            pageProDetail:pageProDetail,
            pageMeetingList:pageMeetingList,
            pageMeetingDetail:pageMeetingDetail,
            pageSpecialDetail:pageSpecialDetail,
            pageOrganDetail:pageOrganDetail,
            pageBrand:pageBrand,
            pageBrandList:pageBrandList,
            pageCompany:pageCompany,
            pagesetMeta:pagesetMeta,
            pageOrgMeta:pageOrgMeta,
            pageProductMeta:pageProductMeta,
        },
        state: defaultStates,
        mutations:mutations,
        actions:actions,
        getters:getters
    });

    //热更新
    if (module.hot){
        module.hot.accept([
            './state/state',
            './mutations/mutations',
            './actions/actions',
            './getters/getters'
        ],()=>{
            const newState = require('./state/state').default;
            const newMutations = require('./mutations/mutations').default;
            const newActions = require('./actions/actions').default;
            const newGetters = require('./getters/getters').default;
            store.hotUpdate({
                state:newState,
                mutations:newMutations,
                actions:newActions,
                getters:newGetters
            });
        });
    }
    return store;
}
